import {
  Box,
  Card,
  RadioButton,
  Text,
  WizardStepRenderParams,
} from '@factorialco/deprecated-design-system'
import { AvailableModules, Features } from 'generated/featureDefinitions'

import TextArea from 'modules/core/components/TextArea'
import i18n from 'modules/core/lib/i18n'

import { PulseConfiguration } from 'modules/engagement/lib/pulse'
import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'

export const MessageStep = ({
  data,
  onDataChanged,
  hasEngagement,
  canRequestUpsell,
}: WizardStepRenderParams<PulseConfiguration> & {
  hasEngagement: boolean
  canRequestUpsell: boolean
}) => {
  return (
    <Box gap="s16">
      <Box gap="s16">
        <Card onClick={() => onDataChanged({ ...data, questionType: 'daily_question' })}>
          <Card.Title
            action={
              <RadioButton
                value="daily"
                checked={data.questionType === 'daily_question'}
                onChange={() => onDataChanged({ ...data, questionType: 'daily_question' })}
              />
            }
          >
            {i18n.t('engagement.pulse.activation.message.daily_question.title')}
          </Card.Title>
        </Card>

        <Card onClick={() => onDataChanged({ ...data, questionType: 'weekly_question' })}>
          <Card.Title
            action={
              <RadioButton
                value="daily"
                checked={data.questionType === 'weekly_question'}
                onChange={() => onDataChanged({ ...data, questionType: 'weekly_question' })}
              />
            }
          >
            {i18n.t('engagement.pulse.activation.message.weekly_question.title')}
          </Card.Title>
        </Card>

        {!hasEngagement && canRequestUpsell && (
          <Card>
            <Card.Content>
              <Box gap="s16">
                <Box
                  flexDirection="row"
                  justifyContent="spaceBetween"
                  alignItems="center"
                  width="full"
                >
                  <Text size="400" weight="semibold" color="black">
                    {i18n.t('engagement.pulse.activation.message.custom.title')}
                  </Text>
                  <UpsellingKit.UpsellButton
                    requestSource="engagement-pulse-settings"
                    pageSource="engagement-pulse-settings"
                    requestReason={ValidReasons.MissingAddon}
                    moduleRequested={AvailableModules.surveys}
                    featureRequested={Features.surveys_core}
                  />
                </Box>
                <Card.Description>
                  {i18n.t('engagement.pulse.activation.message.custom.description')}
                </Card.Description>
              </Box>
            </Card.Content>
          </Card>
        )}

        {hasEngagement && (
          <Card onClick={() => onDataChanged({ ...data, questionType: 'custom' })}>
            <Card.Title
              action={
                <RadioButton
                  value="daily"
                  checked={data.questionType === 'custom'}
                  onChange={() => onDataChanged({ ...data, questionType: 'custom' })}
                />
              }
            >
              {i18n.t('engagement.pulse.activation.message.custom.title')}
            </Card.Title>
            <Card.Description>
              {i18n.t('engagement.pulse.activation.message.custom.description')}
            </Card.Description>

            <Card.ExpandableContent expanded={data.questionType === 'custom'}>
              <TextArea
                mandatory={data.questionType === 'custom'}
                placeholder={i18n.t('engagement.pulse.activation.message.custom.placeholder')}
                value={data.question}
                onChange={(value: string) => {
                  onDataChanged({ ...data, question: value })
                }}
                maxLength={255}
              />
            </Card.ExpandableContent>
          </Card>
        )}
      </Box>
    </Box>
  )
}
